module.exports = __webpack_public_path__ + "static/media/OpenSans-ExtraBold.8bac22ed.ttf";